export const formatCardCode = (v: string) => {
  const nMask = v.replace(/\D/g, "").slice(0, 3)

  const f = nMask

  return f
}
